import React from 'react';

import styles from './LearnerEmailBadge.module.scss';

function LearnerEmailBadge({ email }) {
  return (
    <div className={styles.root}>
      Learner Email
      <span className={styles.emailContainer}>{email}</span>
    </div>
  );
}

export default LearnerEmailBadge;
